module.exports = __webpack_public_path__ + "static/img/1.0086a85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/1.jpg
// module id = CYRW
// module chunks = 1